import '../../public/static/css/base.css';
import '../../public/static/css/common.css';
import '../../public/static/css/etc.css';
import { DEEP_LINK, DEEP_LINK_MARKET } from '../enum/Constants';
import { firebaseInit } from './firebase';
import { closeDialog, isApp, isIOS, openDialog } from './utils';
var goAppLink = function () {
    if (isApp()) {
        window.parent.location.href = "".concat(DEEP_LINK, "/my");
    }
    else if (isIOS()) {
        openDialog('iOS 앱은 준비중입니다.', closeDialog);
    }
    else {
        window.open("".concat(DEEP_LINK_MARKET), '_self');
    }
};
var initialize = function () {
    firebaseInit();
    var download = document.getElementById('download');
    if (download) {
        download.addEventListener('click', goAppLink);
    }
};
initialize();
